module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n3n4n8r-fb015b5f061f56f6f0fdc50f3e04b021.svg";